import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No lending backend exists in this
// environment: the margin incident summary, health-factor timeline, and assignee name were
// previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLendingIncidentPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Lending", href: "/treasury/lending" }], label: "Margin Incident" }}
      state={{
        title: "Margin incident detail is not available in this environment yet",
        description: "Margin incident tracking and mitigation actions require the lending risk-monitoring backend, which does not exist in this environment yet.",
      }}
    />
  );
}
